import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OAuthMfaResponse } from 'src/app/modules/authentication/models/oauth-response';
import { Conflict } from 'src/app/shared/model/exception/conflict-exception.model';
import { createConflictMessage } from 'src/app/shared/util/conflict.utils';
import { isNullOrEmpty } from 'src/app/shared/util/string-helper.util';
import { MessageService } from '../services/message.service';

export const IGNORE_ERRORS = new HttpContextToken(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private messageService: MessageService,
    private nzMessageService: NzMessageService,
    private readonly router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown, _: Observable<HttpEvent<unknown>>) => {
        if (error instanceof HttpErrorResponse && request.context.get(IGNORE_ERRORS) !== true) {
          if (request.url.includes('/token')) {
            const oauthError = error.error as OAuthMfaResponse;
            let errorMessage = '';
            if (!isNullOrEmpty(oauthError.error_description)) {
              errorMessage = oauthError.error_description;
            } else {
              errorMessage = error?.error?.message ?? error.message;
            }
            this.messageService.showError(errorMessage);
            return throwError(() => error);
          }
          switch (error.status) {
            case 0: // Timeout
              this.messageService.showError($localize`De server reageerde niet binnen een aanvaardbare tijd.`);
              break;
            case 404:
              this.messageService.showError($localize`De gevraagde gegevens werden niet gevonden op de server.`);
              break;
            case 409:
              if (error?.error?.conflicts) {
                error.error.conflicts.forEach((conflict: Conflict) => {
                  const errorMessage = createConflictMessage(conflict, this.router);
                  this.nzMessageService.error(errorMessage, { nzDuration: 8_000 });
                });
              } else {
                this.messageService.showError(
                  $localize`Er is een conflict met de ingegeven data en de data op de server. Dit kan mogelijk gaan over overlappende gegevens.`,
                  error?.error?.message
                );
              }
              break;
            default:
              this.messageService.showError(error?.error?.message ?? error.message);
          }
        }
        return throwError(() => error);
      })
    );
  }
}
